export default __webpack_public_path__ + "static/media/38.724bf5e3.jpg";